export const softskillBlocksExport = ['interpersonal', 'social', 'methodical', 'languages', 'technological']
export const hardskillBlocksExport = ['interpersonal', 'social', 'methodical', 'languages', 'technological']

let skillBlocks = { 'softskillBlocksExport': softskillBlocksExport, 'hardskillBlocks': hardskillBlocksExport}

export default skillBlocks